import { useEffect } from "react";

export default function useVersionCheck() {

    useEffect(() => {

        const check = async () => {

            const res = await fetch("/version.json?t=" + Date.now(), {
                cache: "no-store"
            });

            const data = await res.json();

            const current = localStorage.getItem("app_version");

            if (!current) {
                localStorage.setItem("app_version", data.version);
                return;
            }

            if (current !== data.version) {
                localStorage.setItem("app_version", data.version);
                window.location.reload();
            }

        };

        check();

        const interval = setInterval(check, 5 * 60 * 1000);

        return () => clearInterval(interval);

    }, []);

}